import React from 'react';

import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import Icon from '@components/utils/IconWrap';

export default function NavPopover({
  label = 'Product',
  buttonClassName = 'group',
  children,
}) {
  return (
    <Popover className={buttonClassName}>
      <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-base-content focus:outline-none cursor-pointer">
        {label}
        <Icon
          icon="mdi:chevron-down"
          aria-hidden="true"
          className="size-5 flex-none text-base-content/50 group-data-[open]:rotate-180 transition-transform duration-200"
        />
      </PopoverButton>

      <PopoverPanel
        transition
        className="absolute inset-x-0 top-0 -z-10 bg-base-100 pt-14 shadow-lg ring-1 ring-base-content/5 transition data-[closed]:-translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
      >
        {children}
      </PopoverPanel>
    </Popover>
  );
}
